import R from 'ramda'
import auto from 'async/auto'
import {defineMessages} from 'react-intl'

import {getSummaries} from '../api/search' 

import fetchDirections from './fetchDirections'
import fetchDetails from './fetchDetails'
import addNotification from './addNotification'

import getCurrentQuery from '../utils/getCurrentQuery'

import sortedEstateList from '../selectors/sortedEstateList'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "While selecting this estate, an error occured, try again later", 
    defaultMessage: "While selecting this estate, an error occured, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

export default (estateId) => (dispatch, getState) => {

  const query = getCurrentQuery()
  
  const doFetchDirections = (cb) => cb(null, dispatch(fetchDirections(query, estateId)))

  auto({
    fetchDirections: doFetchDirections,
  }, (err, results) => {
    if(err){
      return console.error("Failed to show directions", err)
    }
    dispatch({type: 'show_directions', estateId})
  })
}




/** WEBPACK FOOTER **
 ** ./app/actions/showDirections.js
 **/